<template>
  <el-row class="articleContent">
    <el-col :span="24">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >公共服务</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/public-service' }"
          >信息查询服务</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ regulations.laws }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="grid-content bg-purple-dark">
        <p class="tlt1">{{ regulations.laws }}</p>
        <p class="tlt3">
          浏览次数：<span>{{ regulations.num }}</span>
        </p>
        <p class="tlt2">（数据来源：国家文物局政府网站）</p>
        <div class="hxl_title"></div>
      </div>
      <div class="announcement">
        <div class="ipt">
          <el-input
            v-model="searchOn"
            maxlength="24rem"
            placeholder="请输入县名"
            class="input-with-select"
          >
            <el-button
              class="searchFor"
              slot="append"
              size="small"
              @click="seeSer()"
              >搜索</el-button
            >
          </el-input>
          <el-button size="small" class="reset" @click="resetOn()"
            >重置</el-button
          >
        </div>
        <div class="dat">
          <div class="paging">
            <el-select
              clearable
              v-model="state"
              placeholder="省份"
              class="sele"
              @change="stateChange"
            >
              <el-option
                v-for="item in stateList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>

            <el-select
              clearable
              v-model="partition"
              placeholder="分区"
              class="sele"
              @change="partitionChange"
            >
              <el-option
                v-for="item in partitionList"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <el-button
              size="small"
              icon="el-icon-refresh"
              class="refresh"
              @click="refresh()"
              >刷新</el-button
            >
          </div>
        </div>
        <div style="padding: 0 20px; text-align: center">
          <el-table
            :span-method="arraySpanMethod"
            :data="legalForms"
            :stripe="true"
            border
            fit
            style="width: 100%"
            :header-cell-style="{
              background: '#ebe6db',
              color: '#585856',
              borderColor: '#585856',
            }"
            :cell-style="{ borderColor: '#585856' }"
          >
            <el-table-column
              align="center"
              prop="num"
              label="序号"
              min-width="60px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="batchNum"
              label="批次"
              min-width="170px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="province"
              label="分区"
              min-width="170px"
            >
            </el-table-column>

            <el-table-column
              align="center"
              prop="city"
              label="省名"
              min-width="108px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="zone"
              label="市名"
              min-width="108px"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="remake"
              label="县名"
              min-width="430px"
            >
            </el-table-column>
          </el-table>
          <el-pagination
            popper-class="pageclass"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 40, 80]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import {
  URL_DESCRIPTION_FIND,
  URL_COMPREHENSIVE_EXCUSE,
} from "../../../utils/api";
import util from "../../../utils/util";
import { objectSpan } from "../../../utils/mergecell";
import { frontHeater } from "../../../utils/md5encryption";
export default {
  inject: ["reload"],
  props: [],
  components: {},
  data() {
    return {
      // 基本数据
      regulations: {
        //  标题+面包屑
        laws: "革命文物保护利用片区分县名单（第一批）",
        // 浏览次数
        num: "2",
      },
      //   省份
      stateList: [],
      //  分区
      partitionList: [],
      //省份
      state: null,
      //分区
      partition: null,
      //   搜索
      searchOn: null,
      // 表格
      legalForms: [],

      // 前往页数
      currentPage: 1,
      // 条数
      pagesize: 20,
      total: 0,
      a: [],
    };
  },
  computed: {},
  // classCode: "SubareaClass"
  methods: {
    objectSpanMethod({ column, rowIndex }) {
      return objectSpan({ column, rowIndex }, this.legalForms, "province", [
        "序号",
        "批次",
        "分区",
        "省名",
      ]);
    },
    // 请求数据
    getList() {
      let result = frontHeater(
        ["subarea", "province"],
        [this.partition, this.state]
      );
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        pageNation: { pageNumber: this.currentPage, pageSize: this.pagesize },
        keyWord: this.searchOn,
        subarea: this.partition,
        province: this.state,
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      // this.$http.defaults.headers.common["subarea"] = this.partition;
      this.$http.defaults.headers.common["province"] = this.state;
      this.$http.post(Url + `/api/revolutionary/find`, params).then((res) => {
        if (res.status == 200) {
          console.log(res.data);
          this.total = res.data.data.recordsTotal;
          this.legalForms = [];
          let list = res.data.data.data;
          list.forEach((item) => {
            for (let i of item.data) {
              for (let c of i.data) {
                let obj = {
                  batchNum: item.batchNum,
                  city: i.province,
                  zone: c.city,
                  remake: c.county,
                  province: item.subarea,
                  num: item.num,
                };
                this.legalForms.push(obj);
              }
            }
            this.merage();
          });
        }
      });
    },
    arraySpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        //第一列的合并方法,省
        const _row_1 = this.provinceArr[rowIndex];
        const _col_1 = _row_1 > 0 ? 1 : 0; //如果被合并了_row=0则它这个列需要取消
        return {
          rowspan: _row_1,
          colspan: _col_1,
        };
      } else if (columnIndex === 1) {
        //第一列的合并方法,省
        const _row_1 = this.provinceArr[rowIndex];
        const _col_1 = _row_1 > 0 ? 1 : 0; //如果被合并了_row=0则它这个列需要取消
        return {
          rowspan: _row_1,
          colspan: _col_1,
        };
      } else if (columnIndex === 2) {
        //第一列的合并方法,省
        const _row_1 = this.provinceArr[rowIndex];
        const _col_1 = _row_1 > 0 ? 1 : 0; //如果被合并了_row=0则它这个列需要取消
        return {
          rowspan: _row_1,
          colspan: _col_1,
        };
      } else if (columnIndex === 3) {
        //第二列的合并方法,市
        const _row_2 = this.cityArr[rowIndex];
        const _col_2 = _row_2 > 0 ? 1 : 0;
        return {
          rowspan: _row_2,
          colspan: _col_2,
        };
      } else if (columnIndex === 4) {
        //第三列的合并方法,区
        const _row_3 = this.zoneArr[rowIndex];
        const _col_3 = _row_3 > 0 ? 1 : 0;
        return {
          rowspan: _row_3,
          colspan: _col_3,
        };
      }
    },
    merage() {
      //要合并的数组的方法
      this.merageInit();
      for (let i = 0; i < this.legalForms.length; i++) {
        if (i === 0) {
          //第一行必须存在
          this.provinceArr.push(1);
          this.provincePos = 0;
          this.cityArr.push(1);
          this.cityPos = 0;
          this.zoneArr.push(1);
          this.zonePos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同 this.provincePos是provinceArr内容的序号
          //省
          if (this.legalForms[i].province === this.legalForms[i - 1].province) {
            this.provinceArr[this.provincePos] += 1;
            this.provinceArr.push(0);
          } else {
            this.provinceArr.push(1);
            this.provincePos = i;
          }
          //市
          if (
            this.legalForms[i].city === this.legalForms[i - 1].city &&
            this.legalForms[i].province === this.legalForms[i - 1].province
          ) {
            this.cityArr[this.cityPos] += 1;
            this.cityArr.push(0);
          } else {
            this.cityArr.push(1);
            this.cityPos = i;
          }
          //区
          if (
            this.legalForms[i].zone === this.legalForms[i - 1].zone &&
            this.legalForms[i].city === this.legalForms[i - 1].city &&
            this.legalForms[i].province === this.legalForms[i - 1].province
          ) {
            this.zoneArr[this.zonePos] += 1;
            this.zoneArr.push(0);
          } else {
            this.zoneArr.push(1);
            this.zonePos = i;
          }
        }
      }
    },
    merageInit() {
      //初始化省市区的合并行的数组
      this.provinceArr = [];
      this.provincePos = 0;
      this.cityArr = [];
      this.cityPos = 0;
      this.zoneArr = [];
      this.zonePos = 0;
    },
    // 获取浏览次数
    getNumberViews() {
      let result = frontHeater(["dataType"], ["DataRevolutionaryCultural"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        dataType: "DataRevolutionaryCultural",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["dataType"] =
        "DataRevolutionaryCultural";
      this.$http.post(Url + URL_DESCRIPTION_FIND, params).then((res) => {
        if (res.status === 200) {
          this.regulations.num = res.data.data.viewTimes;
        }
      });
    },
    // 获取省份
    getProvinceList() {
      let result = frontHeater(["ClassCode"], ["DistrictCode"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "DistrictCode",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] = "DistrictCode";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.stateList = res.data.data;
        }
      });
    },
    // 获取分区
    getPartitionList() {
      let result = frontHeater(["ClassCode"], ["SubareaClass"]);
      let Url = util.getAjaxUrl("axiosTWo");
      let params = {
        ClassCode: "SubareaClass",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["ClassCode"] = "SubareaClass";
      this.$http.post(Url + URL_COMPREHENSIVE_EXCUSE, params).then((res) => {
        if (res.status == 200) {
          this.partitionList = res.data.data;
        }
      });
    },
    // 搜索
    seeSer() {
      this.getList();
    },
    // 重置
    resetOn() {
      this.searchOn = null;
      this.state = null;
      this.partition = null;
      this.currentPage = 1;
      this.pagesize = 20;
      this.getList();
    },
    // 刷新
    refresh() {
      this.resetOn();
    },

    // 确定页数
    handleSizeChange(val) {
      this.pagesize = val;
      this.getList();
    },
    // 当前页数
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    stateChange() {
      this.getList();
    },
    partitionChange() {
      this.getList();
    },
  },
  mounted() {
    // this.regulations.laws = this.$route.query.title;
    this.getList();
    this.getNumberViews();
    this.getProvinceList();
    this.getPartitionList();
  },
};
</script>
<style scoped lang='less'>
@import "../../../styles/theme";
@import "../../../styles/comSty";
@import "../../../styles/Hierarchy";

.tlt1 {
  font-size: 18px;
  font-weight: 700;
  color: #b71c1c;
  margin: 10px 0;
  text-align: center;
}
.tlt2 {
  margin: 0;
  text-align: center;
  font-size: 16px;
}
.tlt3 {
  margin: 0 auto;
  padding-right: 40px;
  text-align: right;
  font-size: 16px;
  color: #444;
  font-weight: 700;
  span {
    color: @theme-color;
  }
}
.hxl_title {
  font-size: 22px;
  padding-bottom: 10px;
  color: #b71c1c;
  border-bottom: 3px solid #b71c1c;
}

.sele {
  width: 170px;
  height: 32px;
  margin: 10px 0;
}
.dat {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  // margin-bottom: 10px;
}
/deep/.el-input--suffix .el-input__inner {
  height: 32px;
  .el-input__icon {
    height: 100%;
    width: 25px;
    text-align: center;
    transition: all 0.3s;
    line-height: 30px;
  }
}
</style>